// extracted by mini-css-extract-plugin
module.exports = {"titleAndTextWrapper":"downloadPdf_titleAndTextWrapper__z2d3y","downloadAnchor":"downloadPdf_downloadAnchor__B6MLC"};